import { render } from "./InventoryMenu.vue?vue&type=template&id=2e64050e&bindings={\"items\":\"props\",\"subject\":\"props\",\"hoverHandler\":\"options\",\"rightClickHandler\":\"options\",\"isItemPicked\":\"options\",\"makeItemBackground\":\"options\"}"
import script from "./InventoryMenu.vue?vue&type=script&lang=js"
export * from "./InventoryMenu.vue?vue&type=script&lang=js"

import "./InventoryMenu.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script